export default __webpack_public_path__ + "static/media/External_url.1f418658.svg";